import { PayloadRequestGarantias } from "@interfaces/request";
import { baseApi } from "./baseApi";
import {
  GarantiasVehicularInmobiliariaResponse,
  GetGarantiasVehicularInmobiliariaResponse,
  GuaranteeVehicleDetailConfig,
  GuaranteeVehicleDetailConfigResponse,
  PayloadRequestGarantiasVehicularInmobiliaria,
} from "@interfaces/index";

const guaranteesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    postGuaranteesTypes: build.mutation<
      PayloadRequestGarantias,
      { loan_application_id: string; data: PayloadRequestGarantias }
    >({
      query: ({ loan_application_id, data }) => ({
        url: `solicitudes/${loan_application_id}/garantias?q=active:true`,
        method: "POST",
        body: data,
      }),
    }),

    getGuaranteesData: build.query<GarantiasVehicularInmobiliariaResponse[], { loan_application_id: string }>({
      query: ({ loan_application_id }) => `solicitudes/${loan_application_id}/garantias?q=active:true`,
      transformResponse: (response: GetGarantiasVehicularInmobiliariaResponse) => {
        return response.data.data;
      },
    }),

    deleteGuaranteesTypes: build.mutation<Response, { loan_application_id: string; guarantee_id: string }>({
      query: ({ loan_application_id, guarantee_id }) => ({
        url: `solicitudes/${loan_application_id}/garantias/${guarantee_id}`,
        method: "DELETE",
      }),
    }),

    patchGuaranteesTypes: build.mutation<
      PayloadRequestGarantiasVehicularInmobiliaria,
      { loan_application_id: string; data: PayloadRequestGarantiasVehicularInmobiliaria; guarantee_id: string }
    >({
      query: ({ loan_application_id, data, guarantee_id }) => ({
        url: `solicitudes/${loan_application_id}/garantias/${guarantee_id}`,
        method: "PATCH",
        body: data,
      }),
    }),
    getGuaranteeTypeDetailConfig: build.query<GuaranteeVehicleDetailConfig[], { guarantee_type_id: string; taxcode: string }>({
      query: ({ guarantee_type_id, taxcode }) =>
        `catalogos/guarantee_type_detail_config?taxcode=${taxcode}&q=guarantee_type_id:${guarantee_type_id}`,
      transformResponse: (response: GuaranteeVehicleDetailConfigResponse) => {
        return response.data.data;
      },
    }),
  }),
});

export const {
  usePostGuaranteesTypesMutation,
  useLazyGetGuaranteesDataQuery,
  useDeleteGuaranteesTypesMutation,
  usePatchGuaranteesTypesMutation,
  useLazyGetGuaranteeTypeDetailConfigQuery,
} = guaranteesApi;
